import { FaHeading } from "react-icons/fa";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Opening text",
  name: "openingText",
  icon: FaHeading,
  type: "object",
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    },
    {
      name: "subtitle",
      title: "Subtitle",
      type: "multilingualArrayString"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "([Opening] text)",
        subtitle: "Opening Text"
      };
    }
  }
});
